<app-top-nav></app-top-nav>
<p-tabView>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <a>
                <mat-icon class="material-icons-outlined">
                    manage_accounts
                </mat-icon>
                <span i18n="@@admin.panel.navigation.fiberhoodcontact">
                  Fiberhood contact info
                </span>
              </a>
        </ng-template>
        <app-admin-panel-fiber-hood-contacts></app-admin-panel-fiber-hood-contacts>
    </p-tabPanel>
    <p-tabPanel *ngIf="canViewBulkSettings">
        <ng-template pTemplate="header">
            <a>
                <mat-icon class="material-icons-outlined">
                  tune
                </mat-icon>
                <span i18n="@@admin.panel.navigation.bulkconfiguration">
                  Bulk Config
                </span>
              </a>
        </ng-template>
        <app-admin-bulk-configuration></app-admin-bulk-configuration>
    </p-tabPanel>
    <p-tabPanel *ngIf="canViewGeneralSettings">
        <ng-template pTemplate="header">
            <a>
                <mat-icon class="material-icons-outlined">
                    settings
                </mat-icon>
                <span i18n="@@admin.settings.generalsettings">
                  General settings
                </span>
              </a>
        </ng-template>
        <app-admin-panel-general-settings></app-admin-panel-general-settings>

    </p-tabPanel>
</p-tabView>
